



















import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CONFIG from "@/common/config";

import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';

@Component
export default class BGMIcon extends Vue {
  @Getter("showWantDo") showWantDo!: boolean;
  @Getter("iWantDoIcon") iWantDoIcon!: string;
  @Getter("documentTitle") documentTitle!: string;
  
  getUrlParam: Function = getUrlParam;

  handleClickRecruit(): void {
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener("WeixinJSBridgeReady", this.ready, false);
    } else {
      this.ready();
    }
    if (window.__wxjs_environment === "miniprogram") {
      if (window.TDAPP) {
        window.TDAPP.onEvent("点击【我也要招生】", "小程序", {
          活动名称: this.documentTitle,
          活动类型: CONFIG.templateMap[getActivityType()]
        });
      }
    } else {
      if (window.TDAPP) {
        window.TDAPP.onEvent("点击【我也要招生】", "H5", {
          活动名称: this.documentTitle,
          活动类型: CONFIG.templateMap[getActivityType()]
        });
      }
    }
  }

  ready(): void {
    if (window.__wxjs_environment === "miniprogram") {
      window.wx.miniProgram.redirectTo({
        url: `/pages/recruit/index?redirectUri=https://mp.weixin.qq.com/s/xFBKURaVWpoiu5ioJKGh1g`
      });
    } else {
      window.location.replace(
        "https://mp.weixin.qq.com/s/xFBKURaVWpoiu5ioJKGh1g"
      );
    }
  }
}
